<template>
  <div class="pcc-progress-notes">
    <table-heading :title="TITLE">
      <template slot="right-alignment">
        <el-pagination v-if="!loadError" layout="sizes, prev, pager, next" :current-page="page" :page-sizes="PAGE_SIZE_OPTIONS" :page-size="pageSize" :total="total" @size-change="sizeChanged" @current-change="pageChanged"></el-pagination>
      </template>
    </table-heading>
    <div v-if="loadError" class="pcc-progress-notes-error">{{ LOAD_ERROR_MESSAGE }}</div>
    <el-table v-else class="table" :data="notes" v-loading="loading">
      <el-table-column label="Note Type" :width="TYPE_COLUMN_WIDTH">
        <template scope="scope">
          {{ scope.row.noteType }}
        </template>
      </el-table-column>
      <el-table-column label="Note details">
        <template scope="scope">
          <span style="white-space: pre-line">{{ details(scope.row) }}</span>
        </template>
      </el-table-column>
      <el-table-column label="User" :width="USER_COLUMN_WIDTH">
        <template scope="scope">
          {{ scope.row.providerName }}
        </template>
      </el-table-column>
      <el-table-column label="Date" :width="DATE_COLUMN_WIDTH">
        <template scope="scope">
          {{ formatDate(scope.row.created) }}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import moment from "moment";
import { listProgressNotes, PROVIDER_SECTION_NAME } from "../../services/PccProgressNoteService";
import CaseDetailHeading from "../Shared/CaseDetailTableHeading";

const DEFAULT_PAGE_SIZE = 10;
const PAGE_SIZE_OPTIONS = [5, 10, 20, 100]; // same choices as the other case tabs; API caps size at 100
const FIRST_PAGE = 1;
const TYPE_COLUMN_WIDTH = 160;
const USER_COLUMN_WIDTH = 160;
const DATE_COLUMN_WIDTH = 190;
const TIME_FORMAT = "h:mm A";
const LOAD_ERROR_MESSAGE = "Could not load PointClickCare notes.";
const TITLE = "Progress Notes";

export default {
  name: "pcc-progress-notes-tab",
  props: ["clientId", "caseId"],
  components: {
    "table-heading": CaseDetailHeading
  },
  data: function() {
    return {
      notes: [],
      total: 0,
      page: FIRST_PAGE,
      pageSize: DEFAULT_PAGE_SIZE,
      loading: false,
      loadError: false,
      PAGE_SIZE_OPTIONS,
      TYPE_COLUMN_WIDTH,
      USER_COLUMN_WIDTH,
      DATE_COLUMN_WIDTH,
      LOAD_ERROR_MESSAGE,
      TITLE
    };
  },
  watch: {
    caseId: function() {
      this.resetAndReload();
    },
    clientId: function() {
      this.resetAndReload();
    }
  },
  methods: {
    resetAndReload: function() {
      this.page = FIRST_PAGE;
      this.notes = [];
      this.total = 0;
      this.$emit("count", this.total);
      this.reload();
    },
    details: function(note) {
      return (note.sections || [])
        .filter(s => s.name !== PROVIDER_SECTION_NAME)
        .map(s => s.value)
        .join("\n");
    },
    formatDate: function(value) {
      return value ? moment(value).format(`${this.$configStore.dateFormat()} ${TIME_FORMAT}`) : "";
    },
    pageChanged: function(page) {
      this.page = page;
      this.reload();
    },
    sizeChanged: function(size) {
      this.pageSize = size;
      this.page = FIRST_PAGE;
      this.reload();
    },
    reload: async function() {
      const requestId = ++this.latestRequestId;
      this.loading = true;
      try {
        const { content, totalElements } = await listProgressNotes(this.$http, {
          clientId: this.clientId,
          sourceId: this.caseId,
          page: this.page,
          size: this.pageSize,
          includeUnconfirmed: false
        });
        if (requestId !== this.latestRequestId) {
          return;
        }
        this.notes = content || [];
        this.total = totalElements || 0;
        this.loadError = false;
        this.$emit("count", this.total);
      } catch (e) {
        if (requestId === this.latestRequestId) {
          this.loadError = true;
        }
      } finally {
        if (requestId === this.latestRequestId) {
          this.loading = false;
        }
      }
    }
  },
  created: function() {
    this.latestRequestId = 0; // non-reactive stale-response token
  },
  mounted: function() {
    this.resetAndReload();
  }
};
</script>
